import { render, staticRenderFns } from "./MensualidadesAdjunto.vue?vue&type=template&id=028e717a&scoped=true"
import script from "./MensualidadesAdjunto.vue?vue&type=script&lang=js"
export * from "./MensualidadesAdjunto.vue?vue&type=script&lang=js"
import style0 from "./MensualidadesAdjunto.vue?vue&type=style&index=0&id=028e717a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e717a",
  null
  
)

export default component.exports